import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslocoRootModule } from './transloco-root.module';

// Http interceptors
import { TokenInterceptor } from './interceptors/token.interceptor';

// Guards
import { AuthGuard } from './guards/auth-guard/auth.guard';
import { CanActiveCogsigRouteGuard } from './guards/cogsig-guard/can-active-cogsig-route.guard';

// Services
import { AuthService } from './services/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './services/user/user.service';

// Bootstrap
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Intercom
// Intercom removed; chat handled via Gleap in IntercomService
import { ToastrModule } from 'ngx-toastr';
import { TemplateService } from './services/template/template.service';
import { UserSessionService } from './services/user-session/user-session.service';
import { GeneratorStoreService, OwnGeneratorStoreService } from './services/generator-store/generator-store.service';
import { MtCookiesBannerModule } from './modules/root/components/cookies-banner/cookies-banner.module';
import { NoMobileViewModule } from './modules/root/components/no-mobile-view/no-mobile-view.module';
import { MtNavigationHeaderModule } from './modules/root/components/navigation-header/navigation-header.module';
import { DatasetService } from './services/dataset/dataset.service';
import { SignatureDataService } from './services/signature-data/signature-data.service';

/**
 * If we use Material component in modal then we need to import in AppModule
 * Ref: https://github.com/angular/components/issues/19335
 */
import { MatSelectModule } from '@angular/material/select';
import { ColorPickerModule } from 'ngx-color-picker';

// German currency pipe
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { AngularSvgIconModule } from 'angular-svg-icon';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AngularSvgIconModule,
    AngularSvgIconModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ColorPickerModule,
    MatSelectModule,
    MtCookiesBannerModule,
    MtNavigationHeaderModule,
    NgbModule,
    NoMobileViewModule,
    ToastrModule.forRoot(),
    TranslocoRootModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: OwnGeneratorStoreService,
      useFactory:
        (
          datasetService: DatasetService,
          signatureDataService: SignatureDataService,
          templateService: TemplateService
        ) =>
        (id: string) => {
          const ownUserSessionService = new UserSessionService();
          return new GeneratorStoreService(
            datasetService,
            signatureDataService,
            templateService,
            ownUserSessionService,
            id
          );
        },
      deps: [DatasetService, SignatureDataService, TemplateService]
    },
    AuthGuard,
    AuthService,
    CanActiveCogsigRouteGuard,
    CookieService,
    NgbActiveModal,
    UserService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
